import { render, staticRenderFns } from "./Migraine.vue?vue&type=template&id=f9f4252c&scoped=true"
var script = {}
import style0 from "./Migraine.vue?vue&type=style&index=0&id=f9f4252c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9f4252c",
  null
  
)

export default component.exports